export const isExternalLink = (url: string) =>
  url.slice(0, 2) === '//' || url.slice(0, 4) === 'http'
